import React, { lazy, Suspense, useState } from "react";
import { useTranslation } from 'react-i18next';
import SwiperCore from "swiper";
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import { useNavigate } from "react-router-dom";
import "./carousel.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { image1, image2, image3 } from "../../assets/images/carousel";
import { locationIcon } from "../../assets/images/icons";

const LoadingFallback = () => (
  <div className="carousel-loading">
    <div className="loading-placeholder animate-pulse">
      <div className="image-placeholder bg-gray-300"></div>
    </div>
  </div>
);

SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade]);

export default function Carousel() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const carouselSlides = t('carousel.slides', { returnObjects: true });
  const navigate = useNavigate();

  const [searchInput, setSearchInput] = useState("");

  const handleSearch = () => {
    if (searchInput.trim()) {
      navigate(`/hotels?location=${encodeURIComponent(searchInput.trim())}`);
    } else {
      navigate("/hotels");
    }
  };

  return (
    <Suspense fallback={<LoadingFallback />}>
      <div className={`hero_carousel ${isRTL ? "rtl" : ""}`}>
        <Swiper
          className="custom-swiper"
          effect="fade"
          fadeEffect={{ crossFade: true }}
          pagination={{
            clickable: true,
            el: '.swiper-pagination',
            type: 'bullets'
          }}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          allowTouchMove={true}
          loop={true}
        >
          {(Array.isArray(carouselSlides) ? carouselSlides : []).map((slide, index) => (
            <SwiperSlide key={index}>
              <div className="slide_cn">
                <img
                  src={[image1, image2, image3][index] || image1}
                  alt={slide.alt}
                  loading="lazy"
                />
                <div className="slide_overlay" />
                <div className="slide_content">
                  <h1 className="img_title">
                    {slide.title} <span className="blue_text">{slide.highlightedTitle}</span>
                  </h1>
                  <p className="img_disc">{slide.description}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
          <div className="swiper-pagination" />
        </Swiper>

        {/* Floating search bar */}
        <div className="hero_search">
          <div className="hero_search_input">
            <img src={locationIcon} alt="location" className="hero_search_icon" />
            <input
              type="text"
              placeholder={t("home.search_placeholder")}
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            />
          </div>
          <button onClick={handleSearch}>{t("home.search_button")}</button>
        </div>
      </div>
    </Suspense>
  );
}

export const LazyCarousel = lazy(() => import('./Carousel'));
